import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import RecipeDetails from '../components/RecipeDetails';
import Footer from '../components/Footer';

// Recipe data
const recipes = [
	{
		id: 'club-sandwich',
		name: 'Club Sandwich',
		description: 'Der dreistöckige Klassiker mit knusprigem Speck, Hühnchen und frischen Zutaten',
		image: '/assets/images/thankwiches/club.png',
		prepTime: 'PT15M',
		cookTime: 'PT10M',
		totalTime: 'PT25M',
		recipeYield: '1 Portion',
		recipeCategory: 'Sandwich',
		recipeCuisine: 'Amerikanisch',
		difficulty: 'easy',
		rating: 4.5,
		history: 'Das Club Sandwich entstand um 1894 im Saratoga Club House in New York. Der Legende nach wurde es von einem hungrigen Spieler erfunden, der nach einem späten Kartenspiel etwas Herzhaftes brauchte. Der dreistöckige Aufbau mit Hühnchen, Speck und Salat wurde schnell zum Symbol amerikanischer Gastfreundschaft. Heute ist es in fast jedem Restaurant zu finden und verkörpert die Essenz des klassischen amerikanischen Sandwiches.',
		ingredients: ['6 Scheiben Toastbrot', '200g Hühnchenbrust (gekocht)', '4 Scheiben Speck', '1 Tomate', '1/2 Salatkopf', '4 EL Mayonnaise', '2 EL Senf', 'Salz und Pfeffer'],
		instructions: ['Speck in einer Pfanne knusprig braten', 'Hühnchen in dünne Scheiben schneiden', 'Tomate in Scheiben schneiden', 'Salat waschen und trocknen', 'Toastbrot rösten', 'Mayonnaise und Senf mischen', 'Brot mit der Mischung bestreichen', 'Schichtweise belegen: Brot, Salat, Hühnchen, Tomate, Speck', 'Mit zweitem Brot bedecken und wiederholen', 'In Dreiecke schneiden und servieren'],
		nutrition: {
			calories: '650',
			protein: '45g',
			carbs: '35g',
			fat: '35g',
		},
	},
	{
		id: 'croque-monsieur',
		name: 'Croque Monsieur',
		description: 'Französische Eleganz mit geschmolzenem Käse und Schinken',
		image: '/assets/images/thankwiches/croque-monsieur.png',
		prepTime: 'PT10M',
		cookTime: 'PT15M',
		totalTime: 'PT25M',
		recipeYield: '1 Portion',
		recipeCategory: 'Sandwich',
		recipeCuisine: 'Französisch',
		difficulty: 'medium',
		rating: 4.8,
		history: 'Der Croque Monsieur entstand 1910 in einem Pariser Bistro, als ein hungriger Arbeiter sein Brot mit Schinken und Käse belegte und es in der Pfanne braten ließ. Der Name bedeutet "knuspriger Herr" und wurde zum Symbol französischer Bistro-Kultur. Während des Ersten Weltkriegs wurde er zur beliebten Mahlzeit der Pariser Arbeiterklasse. Heute verkörpert er die Eleganz der französischen Küche und ist in jedem Bistro zu finden.',
		ingredients: ['4 Scheiben Weißbrot', '100g Gruyère Käse', '4 Scheiben Schinken', '2 EL Butter', '2 EL Mehl', '200ml Milch', '1 TL Senf', 'Muskatnuss', 'Salz und Pfeffer'],
		instructions: ['Béchamel-Sauce zubereiten: Butter schmelzen', 'Mehl hinzufügen und kurz anrösten', 'Milch langsam unterrühren', 'Mit Senf, Muskatnuss, Salz und Pfeffer würzen', 'Brot mit Schinken und Käse belegen', 'Mit zweiter Brotscheibe bedecken', 'Béchamel-Sauce auf das Sandwich geben', 'Im Ofen bei 200°C goldbraun backen'],
		nutrition: {
			calories: '580',
			protein: '38g',
			carbs: '28g',
			fat: '32g',
		},
	},
	{
		id: 'cuban-sandwich',
		name: 'Cuban Sandwich',
		description: 'Miami-Flair mit Schweinefleisch und Mojo-Sauce',
		image: '/assets/images/thankwiches/cuban.png',
		prepTime: 'PT20M',
		cookTime: 'PT10M',
		totalTime: 'PT30M',
		recipeYield: '1 Portion',
		recipeCategory: 'Sandwich',
		recipeCuisine: 'Kubanisch',
		difficulty: 'medium',
		rating: 4.6,
		history: 'Der Cuban Sandwich entstand in den 1960er Jahren in Miami, als kubanische Einwanderer ihre traditionellen Zutaten mit amerikanischen Sandwich-Techniken kombinierten. Das Schweinefleisch mit Mojo-Sauce und die Kombination aus Schinken und Käse spiegelt die Fusion kubanischer und amerikanischer Küche wider. In den 1980er Jahren wurde er zum Symbol der kubanisch-amerikanischen Gemeinschaft in Florida und ist heute ein fester Bestandteil der Miami-Küche.',
		ingredients: ['2 Cuban Baguettes', '200g Schweinefleisch (gekocht)', '4 Scheiben Schinken', '4 Scheiben Schweizer Käse', '1 Gurke (in Scheiben)', '2 EL Butter', '2 EL Senf', '1 TL Oregano', 'Salz und Pfeffer'],
		instructions: ['Schweinefleisch in dünne Scheiben schneiden', 'Baguettes längs aufschneiden', 'Mit Senf bestreichen', 'Schichtweise belegen: Schweinefleisch, Schinken, Käse, Gurke', 'Mit Oregano würzen', 'Sandwich schließen', 'Butter in einer Pfanne erhitzen', 'Sandwich von beiden Seiten pressen und braten', 'Goldbraun werden lassen und servieren'],
		nutrition: {
			calories: '720',
			protein: '52g',
			carbs: '42g',
			fat: '38g',
		},
	},
	{
		id: 'katsu-sando',
		name: 'Katsu Sando',
		description: 'Japanische Perfektion mit knusprigem Schnitzel',
		image: '/assets/images/thankwiches/katsu-sando.png',
		prepTime: 'PT30M',
		cookTime: 'PT15M',
		totalTime: 'PT45M',
		recipeYield: '1 Portion',
		recipeCategory: 'Sandwich',
		recipeCuisine: 'Japanisch',
		difficulty: 'hard',
		rating: 4.9,
		history: 'Der Katsu Sando entstand in den 1920er Jahren in Tokyo, als japanische Köche westliche Schnitzel-Techniken mit japanischen Geschmacksrichtungen kombinierten. Das Wort "Katsu" bedeutet "Sieg" und wurde zum Glückssymbol in der japanischen Kultur. Während der Meiji-Zeit wurde er zum Symbol der japanischen Modernisierung und der Fusion von Ost und West. Heute ist er ein fester Bestandteil der japanischen Küche und wird oft vor wichtigen Prüfungen gegessen.',
		ingredients: ['2 Scheiben Weißbrot', '2 Schweineschnitzel', '2 Eier', '100g Panko-Mehl', '50g Mehl', '2 EL Worcestershire-Sauce', '2 EL Ketchup', '1 TL Senf', 'Salz und Pfeffer', 'Öl zum Frittieren'],
		instructions: ['Schweineschnitzel plattieren', 'Mit Salz und Pfeffer würzen', 'In Mehl, Ei und Panko wenden', 'In heißem Öl goldbraun frittieren', 'Auf Küchenpapier abtropfen lassen', 'Tonkatsu-Sauce mischen: Ketchup, Worcestershire, Senf', 'Brot mit Sauce bestreichen', 'Schnitzel zwischen Brot legen', 'In Dreiecke schneiden und servieren'],
		nutrition: {
			calories: '680',
			protein: '48g',
			carbs: '45g',
			fat: '28g',
		},
	},
	{
		id: 'reuben-sandwich',
		name: 'Reuben Sandwich',
		description: 'New Yorker Deli-Tradition mit Pastrami und Sauerkraut',
		image: '/assets/images/thankwiches/reuben.png',
		prepTime: 'PT15M',
		cookTime: 'PT10M',
		totalTime: 'PT25M',
		recipeYield: '1 Portion',
		recipeCategory: 'Sandwich',
		recipeCuisine: 'Amerikanisch',
		difficulty: 'easy',
		rating: 4.7,
		history:
			"Das Reuben Sandwich entstand 1928 im Reuben's Restaurant in New York, als der Besitzer Arnold Reuben es für eine hungrige Schauspielerin kreierte. Die Kombination aus Pastrami, Sauerkraut und Thousand Island Dressing wurde zum Symbol der jüdischen Deli-Kultur in New York. Während der 1950er Jahre verbreitete es sich in ganz Amerika und wurde zum Klassiker der amerikanischen Küche. Heute verkörpert es die Einwanderungsgeschichte und die Fusion deutscher und jüdischer Küchentraditionen.",
		ingredients: ['4 Scheiben Roggenbrot', '200g Pastrami', '100g Sauerkraut', '4 Scheiben Schweizer Käse', '4 EL Thousand Island Dressing', '2 EL Butter', 'Salz und Pfeffer'],
		instructions: ['Roggenbrot mit Butter bestreichen', 'Mit Thousand Island Dressing bestreichen', 'Pastrami gleichmäßig verteilen', 'Sauerkraut hinzufügen', 'Käse auflegen', 'Mit zweiter Brotscheibe bedecken', 'In einer Pfanne von beiden Seiten braten', 'Goldbraun werden lassen und servieren'],
		nutrition: {
			calories: '590',
			protein: '42g',
			carbs: '38g',
			fat: '28g',
		},
	},
	{
		id: 'banh-mi',
		name: 'Bánh mì',
		description: 'Knuspriges Baguette, helle Gurken, herzhafte Tiefe in jedem Biss',
		image: '/assets/images/thankwiches/banh-mi.png',
		prepTime: 'PT20M',
		cookTime: 'PT15M',
		totalTime: 'PT35M',
		recipeYield: '1 Portion',
		recipeCategory: 'Sandwich',
		recipeCuisine: 'Vietnamesisch',
		difficulty: 'medium',
		rating: 4.8,
		history:
			'Der Bánh mì entstand in den 1950er Jahren in Saigon, als vietnamesische Köche französische Baguettes mit traditionellen vietnamesischen Zutaten füllten. Nach der französischen Kolonialzeit wurden die Baguettes zur Grundlage für ein neues vietnamesisches Sandwich. Während des Vietnamkriegs wurde er zur beliebten Straßenspeise und verbreitete sich mit vietnamesischen Flüchtlingen in die ganze Welt. Heute verkörpert er die Fusion französischer und vietnamesischer Küche und ist ein Symbol der kulturellen Vielfalt.',
		ingredients: ['2 Baguettes', '200g Schweinefleisch', '1 Gurke', '1 Karotte', '1/2 Daikon', '2 EL Fischsauce', '1 EL Zucker', '1 EL Limettensaft', 'Koriander', 'Chilischoten', 'Mayonnaise'],
		instructions: ['Schweinefleisch marinieren und braten', 'Gurke, Karotte und Daikon in Streifen schneiden', 'Gemüse mit Fischsauce, Zucker und Limettensaft marinieren', 'Baguettes aufschneiden und mit Mayonnaise bestreichen', 'Schweinefleisch einlegen', 'Eingelegtes Gemüse hinzufügen', 'Mit Koriander und Chili garnieren', 'Sandwich schließen und servieren'],
		nutrition: {
			calories: '520',
			protein: '35g',
			carbs: '48g',
			fat: '18g',
		},
	},
	{
		id: 'blt-sandwich',
		name: 'BLT Sandwich',
		description: 'Der zeitlose Klassiker mit knusprigem Speck, frischen Tomaten und knackigem Salat',
		image: '/assets/images/thankwiches/blt.png',
		prepTime: 'PT10M',
		cookTime: 'PT5M',
		totalTime: 'PT15M',
		recipeYield: '1 Portion',
		recipeCategory: 'Sandwich',
		recipeCuisine: 'Amerikanisch',
		difficulty: 'easy',
		rating: 4.4,
		history: 'Das BLT Sandwich entstand in den 1920er Jahren in amerikanischen Restaurants als einfache und beliebte Mahlzeit. Der Name steht für Bacon, Lettuce, Tomato - die drei Hauptzutaten. Während der Wirtschaftskrise wurde es zur beliebten und erschwinglichen Mahlzeit. In den 1950er Jahren verbreitete es sich in ganz Amerika und wurde zum Symbol der amerikanischen Küche. Heute ist es ein fester Bestandteil der amerikanischen Esskultur und wird in fast jedem Restaurant angeboten.',
		ingredients: ['4 Scheiben Toastbrot', '6 Scheiben Speck', '2 Tomaten', '4 Salatblätter', '4 EL Mayonnaise', 'Salz und Pfeffer', 'Butter'],
		instructions: ['Speck in einer Pfanne knusprig braten', 'Tomaten in Scheiben schneiden', 'Salat waschen und trocknen', 'Toastbrot rösten', 'Brot mit Butter bestreichen', 'Mayonnaise auf das Brot streichen', 'Salatblätter auflegen', 'Tomaten darauf verteilen', 'Speck hinzufügen', 'Mit Salz und Pfeffer würzen', 'Mit zweiter Brotscheibe bedecken', 'In Dreiecke schneiden und servieren'],
		nutrition: {
			calories: '520',
			protein: '28g',
			carbs: '32g',
			fat: '32g',
		},
	},
	{
		id: 'choripan',
		name: 'Choripan',
		description: 'Argentinisches Straßensandwich mit würziger Chorizo und Chimichurri',
		image: '/assets/images/thankwiches/choripan.png',
		prepTime: 'PT15M',
		cookTime: 'PT20M',
		totalTime: 'PT35M',
		recipeYield: '1 Portion',
		recipeCategory: 'Sandwich',
		recipeCuisine: 'Argentinisch',
		difficulty: 'medium',
		rating: 4.7,
		history:
			'Der Choripan entstand in den 1950er Jahren in Buenos Aires als beliebtes Straßenessen der Arbeiterklasse. Der Name setzt sich aus "Chorizo" (Wurst) und "Pan" (Brot) zusammen. Während der Wirtschaftskrise wurde er zur erschwinglichen Mahlzeit und entwickelte sich zum Symbol der argentinischen Straßenkultur. Bei Fußballspielen und Festen wurde er zum unverzichtbaren Begleiter. Heute verkörpert er die Leidenschaft der argentinischen Küche und ist ein fester Bestandteil der lateinamerikanischen Gastronomie.',
		ingredients: ['1 Baguette', '200g Chorizo', '1 Zwiebel', '2 Tomaten', '1/2 Bund Petersilie', '3 Knoblauchzehen', '3 EL Olivenöl', '2 EL Essig', '1 TL Oregano', 'Salz und Pfeffer', 'Chimichurri'],
		instructions: ['Chorizo in Scheiben schneiden', 'Zwiebel in Ringe schneiden', 'Tomaten würfeln', 'Chimichurri zubereiten: Petersilie, Knoblauch, Olivenöl, Essig, Oregano mischen', 'Chorizo in einer Pfanne braten', 'Zwiebel glasig dünsten', 'Baguette aufschneiden', 'Mit Chimichurri bestreichen', 'Chorizo und Zwiebel einlegen', 'Tomaten hinzufügen', 'Mit Salz und Pfeffer würzen', 'Sandwich schließen und servieren'],
		nutrition: {
			calories: '680',
			protein: '42g',
			carbs: '45g',
			fat: '38g',
		},
	},
	{
		id: 'francesinha',
		name: 'Francesinha',
		description: 'Portugiesisches Kult-Sandwich mit Fleisch, Käse und würziger Sauce',
		image: '/assets/images/thankwiches/francesinha.png',
		prepTime: 'PT20M',
		cookTime: 'PT15M',
		totalTime: 'PT35M',
		recipeYield: '1 Portion',
		recipeCategory: 'Sandwich',
		recipeCuisine: 'Portugiesisch',
		difficulty: 'hard',
		rating: 4.8,
		history:
			'Die Francesinha entstand 1953 in Porto, als Daniel da Silva das französische Croque Monsieur mit portugiesischen Zutaten und einer würzigen Sauce verfeinerte. Der Name bedeutet "kleine Französin" und wurde zum Symbol der portugiesischen Küche. In den 1960er Jahren verbreitete sie sich in ganz Portugal und wurde zur beliebten Mahlzeit in Bars und Restaurants. Heute ist sie das Nationalgericht von Porto und verkörpert die Leidenschaft der portugiesischen Gastronomie mit ihrer reichen Sauce und den vielfältigen Fleischsorten.',
		ingredients: ['4 Scheiben Weißbrot', '200g Rindfleisch', '100g Schinken', '100g Linguica', '4 Scheiben Käse', '2 Eier', '1 Zwiebel', '2 Knoblauchzehen', '1 Dose Tomaten', '1 Flasche Bier', '2 EL Butter', '1 EL Mehl', 'Worcestershire-Sauce', 'Portwein', 'Salz und Pfeffer'],
		instructions: ['Fleischsorten in Scheiben schneiden', 'Sauce zubereiten: Zwiebel und Knoblauch anbraten', 'Tomaten und Bier hinzufügen', 'Mit Worcestershire-Sauce und Portwein würzen', 'Sauce einkochen lassen', 'Brot mit Butter bestreichen', 'Fleischschichten auflegen', 'Käse darauf verteilen', 'Mit zweiter Brotscheibe bedecken', 'Eier auf das Sandwich legen', 'Sauce darüber gießen', 'Im Ofen gratinieren und servieren'],
		nutrition: {
			calories: '850',
			protein: '58g',
			carbs: '42g',
			fat: '48g',
		},
	},
];

function RecipePage() {
	const { id } = useParams();
	const navigate = useNavigate();
	const [recipe, setRecipe] = useState(null);
	const [triggerHeroAnimation, setTriggerHeroAnimation] = useState(false);

	useEffect(() => {
		const foundRecipe = recipes.find((r) => r.id === id);
		if (foundRecipe) {
			setRecipe(foundRecipe);
			// Trigger hero animation on recipe change
			setTriggerHeroAnimation(true);
			// Reset after animation
			setTimeout(() => {
				setTriggerHeroAnimation(false);
			}, 500);
		}
	}, [id]);

	// Update document title and meta tags for SEO
	useEffect(() => {
		if (recipe) {
			// Set document title
			document.title = `${recipe.name} - Thankwich — Die ikonischsten Sandwiches der Welt`;

			// Update meta description
			const metaDescription = document.querySelector('meta[name="description"]');
			if (metaDescription) {
				metaDescription.setAttribute('content', recipe.description);
			}

			// Update Open Graph tags
			const ogTitle = document.querySelector('meta[property="og:title"]');
			if (ogTitle) {
				ogTitle.setAttribute('content', `${recipe.name} - Thankwich`);
			}

			const ogDescription = document.querySelector('meta[property="og:description"]');
			if (ogDescription) {
				ogDescription.setAttribute('content', recipe.description);
			}

			const ogImage = document.querySelector('meta[property="og:image"]');
			if (ogImage && recipe.image) {
				const fullImageUrl = `${window.location.origin}${recipe.image}`;
				ogImage.setAttribute('content', fullImageUrl);
			}

			const ogUrl = document.querySelector('meta[property="og:url"]');
			if (ogUrl) {
				ogUrl.setAttribute('content', window.location.href);
			}

			// Update Twitter Card tags
			const twitterTitle = document.querySelector('meta[name="twitter:title"]');
			if (twitterTitle) {
				twitterTitle.setAttribute('content', `${recipe.name} - Thankwich`);
			}

			const twitterDescription = document.querySelector('meta[name="twitter:description"]');
			if (twitterDescription) {
				twitterDescription.setAttribute('content', recipe.description);
			}

			// Update canonical URL
			const canonical = document.querySelector('link[rel="canonical"]');
			if (canonical) {
				canonical.setAttribute('href', window.location.href);
			}

			// Cleanup function to reset title when component unmounts
			return () => {
				document.title = 'Thankwich — Die ikonischsten Sandwiches der Welt';
			};
		}
	}, [recipe]);

	const getCurrentIndex = () => {
		return recipes.findIndex((r) => r.id === id);
	};

	const navigateToRecipe = (direction) => {
		const currentIndex = getCurrentIndex();
		let newIndex;

		if (direction === 'prev') {
			newIndex = currentIndex > 0 ? currentIndex - 1 : recipes.length - 1;
		} else {
			newIndex = currentIndex < recipes.length - 1 ? currentIndex + 1 : 0;
		}

		// Navigate immediately without animation
		navigate(`/rezept/${recipes[newIndex].id}`);
	};

	if (!recipe) {
		return (
			<div className="App">
				<Header />
				<div className="container text-center py-5">
					<div className="spinner-border text-primary" role="status">
						<span className="visually-hidden">Loading...</span>
					</div>
				</div>
				<Footer />
			</div>
		);
	}

	return (
		<div className="App">
			<Header />

			{/* Navigation Arrows */}
			<button
				className="btn btn-primary btn-lg rounded mobile-nav-button prev"
				style={{
					position: 'fixed',
					left: '20px',
					top: '50%',
					transform: 'translateY(-50%)',
					width: '60px',
					height: '60px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					zIndex: 1000,
				}}
				onClick={() => navigateToRecipe('prev')}
			>
				<i className="bi bi-chevron-left"></i>
			</button>
			<button
				className="btn btn-primary btn-lg rounded mobile-nav-button next"
				style={{
					position: 'fixed',
					right: '20px',
					top: '50%',
					transform: 'translateY(-50%)',
					width: '60px',
					height: '60px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					zIndex: 1000,
				}}
				onClick={() => navigateToRecipe('next')}
			>
				<i className="bi bi-chevron-right"></i>
			</button>

			{/* Hero Section for Recipe */}
			<section className="hero-section bg-light py-5">
				<div className="container">
					<div className="row align-items-center">
						<div className={`col-12 col-lg-6 text-center text-lg-end order-1 order-lg-2 ${triggerHeroAnimation ? 'hero-slide-right' : ''}`}>
							<img src={recipe.image} alt={recipe.name} className="img-fluid rounded shadow-lg mb-4" style={{ maxHeight: '400px', objectFit: 'cover' }} />
						</div>
						<div className={`col-12 col-lg-6 text-center text-lg-start order-2 order-lg-1 ${triggerHeroAnimation ? 'hero-slide-left' : ''}`}>
							<h1 className="display-4 fw-bold mb-3">{recipe.name}</h1>
							<p className="lead mb-4">{recipe.description}</p>
							<div className="d-flex align-items-center justify-content-center justify-content-lg-start mb-3">
								<span className="badge bg-primary me-2">{recipe.recipeCuisine}</span>
								<span className="badge bg-warning me-2">{recipe.difficulty === 'easy' ? 'Einfach' : recipe.difficulty === 'medium' ? 'Mittel' : 'Schwer'}</span>
								<span className="badge bg-success">{recipe.totalTime.match(/PT(\d+)M/)?.[1] || '0'} Min</span>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* Recipe Details */}
			<RecipeDetails recipe={recipe} />

			<Footer />
		</div>
	);
}

export default RecipePage;
